//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { TrackingId, TrackingIdPrefix } from '@models/TrackingId';

const SETUP_MESSAGING_TRACKING_PREFIX: TrackingIdPrefix =
  'rights-messaging-setup-';

export const SetupMessagingTrackingIds = {
  OPEN_RIGHTS_OPTIONS_MODAL: `${SETUP_MESSAGING_TRACKING_PREFIX}open-modal`,
  TERMS_AND_CONDITIONS_SAVE_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}terms-and-condition-save-button`,
  TERMS_AND_CONDITIONS_BACK_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}terms-and-condition-back-button`,
  RIGHTS_OPTIONS_MESSAGES_BACK_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}rights-options-messages-back-button`,
  ADD_RIGHTS_OPTION_BACK_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}add-rights-option-back-button`,
  ADD_RIGHTS_OPTION_SAVE_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}add-rights-option-save-button`,
  ADD_RIGHTS_OPTION_MESSAGE_SAVE_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}add-rights-option-message-save-button`,
  ADD_RIGHTS_OPTION_MESSAGE_BACK_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}add-rights-option-message-form-back-button`,
  EDIT_RIGHTS_OPTION_ICON: `${SETUP_MESSAGING_TRACKING_PREFIX}edit-rights-option-message-icon`,
  DELETE_RIGHTS_OPTION_ICON: `${SETUP_MESSAGING_TRACKING_PREFIX}delete-rights-option-message-icon`,
  EDIT_TERMS_AND_CONDITIONS_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}edit-terms-and-conditions-button`,
  ADD_RIGHTS_OPTION_FORM_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}add-rights-option-form-button`,
  DELETE_RIGHTS_OPTION_MESSAGE_ICON: `${SETUP_MESSAGING_TRACKING_PREFIX}delete-rights-option-message-icon`,
  EDIT_RIGHTS_OPTION_MESSAGE_ICON: `${SETUP_MESSAGING_TRACKING_PREFIX}edit-rights-option-message-icon`,
  OPEN_BV_TERMS_AND_CONDITIONS_LINK: `${SETUP_MESSAGING_TRACKING_PREFIX}open-bv-terms-and-conditions-link`,
  SELECT_BV_HOSTED_TNC_RADIO_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}select-bv-hosted-tnc-radio-button`,
  SELECT_CUSTOM_TNC_RADIO_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}select-custom-tnc-radio-button`,
  OPEN_CUSTOM_TNC_PREVIEW_LINK: `${SETUP_MESSAGING_TRACKING_PREFIX}open-custom-tnc-preview-link`,
  CUSTOM_TNC_URL_INPUT_TEXT_FIELD: `${SETUP_MESSAGING_TRACKING_PREFIX}custom-tnc-url-input-text-field`,
  SELECT_APPROVAL_PHRASE_DROPDOWN: `${SETUP_MESSAGING_TRACKING_PREFIX}select-approval-phrase-dropdown`,
  SELECT_MESSAGE_TERMS_AND_CONDITIONS_URL: `${SETUP_MESSAGING_TRACKING_PREFIX}select-message-terms-and-conditions-url`,
  ADD_MESSAGING_TEMPLATE_TITLE_TEXT: `${SETUP_MESSAGING_TRACKING_PREFIX}add-messaging-template-title-text-field`,
  ADD_MESSAGE_TEXT_AREA: `${SETUP_MESSAGING_TRACKING_PREFIX}add-message-text-area`,
  SELECT_SETUP_MESSAGING_LANGUAGE: `${SETUP_MESSAGING_TRACKING_PREFIX}select-setup-messaging-language`,
  EDIT_CAMPAIGN_TITLE: `${SETUP_MESSAGING_TRACKING_PREFIX}edit-campaign-title`,
  EDIT_CAMPAIGN_TITLE_BACK_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}edit-campaign-title-back-button`,
  EDIT_CAMPAIGN_TITLE_SAVE_BUTTON: `${SETUP_MESSAGING_TRACKING_PREFIX}edit-campaign-title-save-button`,
  // TODO - PD-285104: Add more tracking ids as needed for setup messaging buttons, eg - termsAndConditions Save button
} as const satisfies Record<string, TrackingId>;
